import { useWorkspaceDataAvailability } from '@/viewmodel/features/dataConsole/hooks/useWorkspaceDataAvailability';

export interface WorkspaceDataAccessViewModel {
  readonly canOpen: boolean;
  readonly isLoading: boolean;
}

export function useWorkspaceDataAccessViewModel(): WorkspaceDataAccessViewModel {
  return useWorkspaceDataAvailability();
}
